module.exports = __webpack_public_path__ + "img/cb-chaneel.55297e4a.svg";